const AuthorizationPermission = {
  NO_CHARGE_BILLING: 'no charge billing',
} as const;

export default AuthorizationPermission;
